(function($) {

	// 
	// Header
	// 
	var $header_position = $('#header').offset().top;
	// console.log( $header_position );

	$(window).on('scroll', function() {
		var $window_scroll   = $(window).scrollTop();

		if ( $window_scroll > $header_position ) {
			$('body').addClass('header-fixed');
		} else {
			$('body').removeClass('header-fixed');
		}
	});

	$('#header-mobile-nav-toggle').on('click', function() {
		$('.mobile-nav-contents').toggleClass('is-active');
	});


	// 
	// smoothScroll
	// 
	$('.tabs-title > [href^="#"]').addClass('noscroll');
	$('a.modal-trigger').addClass('noscroll');

	$('[href^="#"]:not(".noscroll")').SmoothScroll({
		duration: 700,
		easing: 'swing',
		offset: 130,
		hash: false
	});


	//
	// Form
	//
	if ( $('select').find('option:selected').hasClass('no-select') ) {
		$('select').addClass('no-select');
	}

	$('select').on('change', function(){
		if ( $(this).find('option:selected').hasClass('no-select') ) {
			$('select').addClass('no-select');
		} else {
			$('select').removeClass('no-select');
		}
	});


	// 
	// Fair modal
	//
	$('.fair .modal-iframe').magnificPopup({
		type: 'iframe',
		iframe: {
			markup:
				'<div class="mfp-iframe-scaler fair-modal-iframe">' +
					'<div class="mfp-close"></div>' +
					'<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
				'</div>',
		}
	});


	// 
	// 配下ページcarousel
	//
	if ( $('.sub-hero-carousel')[0] ) {
		$('.sub-hero-carousel').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			centerMode: true,
			centerPadding: '10%',
			responsive: [
				{
					breakpoint: 650,
					settings: {
						centerMode: false,
						centerPadding: 0
					}
				}
			]
		});
	}


	// 
	// Ceremony
	// 神社婚 carousel
	//
	if ( $('.program-order-carousel')[0] ) {
		$('.program-order-carousel').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
		});

		$('.program-order-carousel').on('afterChange', function(slick, currentSlide) {
			var current_slide = currentSlide.currentSlide + 1;
			// console.log( current_slide );

			$('.program-order-list li').removeClass('is-active');
			$('.program-order-list li').eq(current_slide - 1).addClass('is-active');
		});

    $('.program-order-list li').click(function () {
      var index = $('.program-order-list li').index(this);
      $('.program-order-carousel').slick('slickGoTo', index);
    });
	}

	// 
	// Banquet
	// ギャラリー：モーダル
	//
	$('.photo-gallery-modal-trigger').magnificPopup({
		type: 'inline',
		gallery: {
			enabled: true
		}
	});


})(jQuery);
